export type GuestOrderFormData = {
  OrderAttachments: FileList[];
  State: StateDetails;
  ConfirmEmail: string;
  UserName: string;
  EmailReceivedDateTime: string;
  ADLOrderID: number;
  RONo: string;
  PONo: string;
  TotalQuantityOrder: number;
  Instructions: string;
  CustomerInfoId: number;
  ShopName: string;
  FirstName: string;
 LastName: string;
  Email: string;
  AccountNumber: string;
  Phone: string;
  ShippingInfoID: number;
  AddressLine1: string;
  AddressLine2: string;
  StreetAddress: string;
  City: string;
  StateID: number;
  StateName: string;
  CountryID: number;
  CountryName: string;
  ZipCode: string;
  CustomerInfoID: number;
  SourceID: number;
  StatusID: number;
  ReferralEmail: string;
  SourceEmail: string;
  IsOvernightDelivery: boolean;
  Cnotes: string;
  PreludeOrderNumber: string;
  ShipViaPost: boolean;
  message?: string;
  error?: string;
  success?: string;
  ReferralSource: ReferralSourceDetails;
  ReferralSourceId: number;
  ReferralSourceOther: string;
  Other: string;
};

export type GuestOrderPayload = {
  OrderAttachments: FileList[];
  UserName: string;
  ADLOrderID: number;
  ReferralSourceID: number;
  RefSourceOthers: string;
  RONo: string;
  PONo: string;
  TotalQty: number;
  Instructions: string;
  "CustomerInfo.CustomerInfoId": number;
  "CustomerInfo.ShopName": string;
  "CustomerInfo.FirstName": string;
  "CustomerInfo.LastName": string;
  "CustomerInfo.Email": string;
  "CustomerInfo.AccountNumber": string;
  "CustomerInfo.PhoneNumber": string;
  "ShippingInfo.ShippingInfoID": number;
  "ShippingInfo.AddressLine1": string;
  "ShippingInfo.AddressLine2": string;
  "ShippingInfo.StreetAddress": string;
  "ShippingInfo.City": string;
  "ShippingInfo.StateID": number;
  "ShippingInfo.StateName": string;
  "ShippingInfo.CountryID": number;
  "ShippingInfo.CountryName": string;
  "ShippingInfo.ZipCode": string;
  "ShippingInfo.CustomerInfoID": number;
  SourceEmail: string;
  SourceID: number;
  StatusID: number;
  IsOvernightDelivery: boolean;
  ShipViaPost: boolean;
  message?: string;
  error?: string;
  success?: string;
};

export interface FileList {
  fileName: string;
  orderAttachmentID: number;
  attachment: File;
  isEmailContent: boolean;
  isActive: boolean;
}

export interface StateDetails {
  countryID: number;
  id: number;
  label: string;
  value: string;
}


export interface ReferralSourceDetails {
  id: number;
  label: string;
  value: string;
}

export interface UploadState {
  files: FileList[];
  duplicates: FileList[];
  invalids: FileList[];
  error: string | null;
}

export type UploadAction =
  | { type: "ADD_FILES"; payload: FileList[] }
  | { type: "REMOVE_FILE"; payload: FileList }
  | { type: "SET_FILES"; payload: FileList[] }
  | { type: "RESET_ERROR" }
  | {
      type: "UPDATE_FILE_CLARITY";
      payload: {
        fileName: string;
        size: number;
        imageQuality: "G" | "B" | "N";
      };
    };

export type GuestOrderState = {
  data: GuestOrderPayload;
  loading: boolean;
  success: boolean;
  error: string | null;
};
export const GuestOrderDefaultValue: GuestOrderPayload = {
  OrderAttachments: [],
  ReferralSourceID: 0,
  RefSourceOthers: "",
  UserName: "",
  RONo: "",
  PONo: "",
  TotalQty: 0,
  Instructions: "",
  IsOvernightDelivery: false,
  "CustomerInfo.CustomerInfoId": 0,
  "CustomerInfo.ShopName": "",
  "CustomerInfo.FirstName": "",
  "CustomerInfo.LastName": "",
  "CustomerInfo.Email": "",
  "CustomerInfo.AccountNumber": "",
  "CustomerInfo.PhoneNumber": "",
  "ShippingInfo.ShippingInfoID": 0,
  "ShippingInfo.AddressLine1": "",
  "ShippingInfo.AddressLine2": "",
  "ShippingInfo.StreetAddress": "",
  "ShippingInfo.City": "",
  "ShippingInfo.StateID": 0,
  "ShippingInfo.StateName": "",
  "ShippingInfo.CountryID": 0,
  "ShippingInfo.CountryName": "",
  "ShippingInfo.ZipCode": "",
  "ShippingInfo.CustomerInfoID": 0,
  SourceID: 0,
  SourceEmail: "",
  StatusID: 0,
  ADLOrderID: 0,
  message: undefined,
  error: undefined,
  ShipViaPost: false,
};
export const initialState: GuestOrderState = {
  data: GuestOrderDefaultValue,
  loading: false,
  success: false,
  error: null,
};

export type GuestOrderServiceOperators = {
  guestOrder: GuestOrderPayload;
  submitGuestOrder: (data: GuestOrderPayload) => void;
};
